import { Component, Prop, Vue } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { Variant } from "../models/product";

@Component
export default class FavouriteIcon extends Vue {

    get dataRole(): string {
        return (this.variant.isInFavouriteList ? "favouritebuttonactive" : "favouritebutton");
    }

    get className(): string {
        return (this.variant.isInFavouriteList ? "favourite-icon favourite-active" : "favourite-icon favourite-inactive");
    }

    get favouriteClassName(): string {
        return "far fa-star" + (this.variant.isInFavouriteList ? " favourite-active" : " favourite-inactive");
    }

    get variant(): Variant {
        return productStore.variant;
    }

    private onClick() {
        const isFavorite = this.variant.isInFavouriteList;
        this.variant.isInFavouriteList = !isFavorite;
        productStore.dispatchVariant(this.variant);

        if (isFavorite) {
            window.Accelerator.libs.favourite.removeArticle(null, null, this.variant.variantId);
        } else {
            window.Accelerator.libs.favourite.addArticle(this.variant.variantId);
        }
    }
}
